import React from 'react'
import styles from './index.module.less'

export default class Header extends React.Component {
  render() {
    return (
      <div className={styles.header}>Design Panel</div>
    )
  }
}
